module.exports = __webpack_public_path__ + "img/5-1.9cbb28a2.jpg";